'use client';

import { useCallback, useMemo, useState } from 'react';

import { Checkbox } from '@repo/ui/checkbox';

import { sortByDate } from 'helpers/format';

import { EventCollection } from 'types/sanity.types';

import EventListItem from 'components/event-list-item';

import { styles } from '.';

type TProps = {
  items?: EventCollection[];
  //
  locale: string;
};

const FilteredList = (props: TProps) => {
  const { items, locale } = props;

  const [arePastEventsShown, setArePastEventsShown] = useState(false);

  const filterPastEvents = useCallback((items?: EventCollection[]) => {
    if (!items) {
      return [];
    }

    return items?.filter((item) => new Date(item?.date) > new Date());
  }, []);

  const results = useMemo(
    () =>
      sortByDate(
        arePastEventsShown ? (items ?? []) : filterPastEvents(items),
        'asc',
      ),
    [arePastEventsShown, filterPastEvents, items],
  );

  return (
    <div className="flex flex-col items-start">
      <div className="flex flex-row gap-x-4 py-4 mb-8 border border-black p-4">
        <Checkbox
          id="are-past-events-shown"
          checked={arePastEventsShown}
          onCheckedChange={(checked) => {
            setArePastEventsShown(checked as any);
          }}
          className="cursor-pointer"
        />
        <label htmlFor="are-past-events-shown" className="cursor-pointer -mt-1">
          Toon voorbije evenementen
        </label>
      </div>
      <ul className={styles.list}>
        {results.map((item) => (
          <EventListItem key={item._id} item={item} locale={locale} />
        ))}
      </ul>
    </div>
  );
};

export default FilteredList;
